import React from 'react';
import { T } from './helpers';

const Console = React.lazy(() => import(/* webpackChunkName: "console" */ 'src/components/pages/console'));

const PlanManager = React.lazy(() => import(/* webpackChunkName: "planManager" */ 'src/components/pages/planManager'));
const ShopifyCharge = React.lazy(() => import(/* webpackChunkName: "shopifyCharge" */ 'src/components/pages/shopifyCharge'));
const WorldMap = React.lazy(() => import(/* webpackChunkName: "worldMap" */ 'src/components/pages/worldMap'));
const MarketplaceThemes = React.lazy(() => import(/* webpackChunkName: "marketplaceThemes" */ 'src/components/pages/marketplaceThemes'));

export interface AdministratorRouteHeader {
    title: React.ReactNode;
    description?: React.ReactNode;
    backUrl?: string;
}

export interface AdministratorRoute {
    url: string;
    component: React.ComponentType<{}> | React.LazyExoticComponent<React.ComponentType<{}>>;
    header: AdministratorRouteHeader | ((params: Record<string, string | undefined>) => AdministratorRouteHeader);
}

const planManagerSubpageHeader = (params: Record<string, string | undefined>): AdministratorRouteHeader => {
    switch (params.subpage) {
        case 'custom-plan':
            return {
                title: T._('Create Custom Plan', 'Admin'),
                description: T._('Set the parameters to create a Custom Plan', 'Admin'),
                backUrl: '/plan-manager'
            };
        case 'extend-trial':
            return {
                title: T._('Extend Free Trial', 'Admin'),
                description: T._('Extend a free trial on Shopify', 'Admin'),
                backUrl: '/plan-manager'
            };
        default:
            return {
                title: T._('Plan Manager', 'Admin'),
                description: T._('Create a Custom Plan and extend a free trial on Shopify.', 'Admin'),
                backUrl: '/plan-manager'
            };
    }
};

const administratorRoutes: AdministratorRoute[] = [
    {
        url: '/console',
        component: Console,
        header: {
            title: T._('Console', 'Admin'),
            description: T._('Monitor earnings by platform.', 'Admin')
        }
    },
    {
        url: '/plan-manager/:subpage',
        component: PlanManager,
        header: planManagerSubpageHeader
    },
    {
        url: '/plan-manager',
        component: PlanManager,
        header: {
            title: T._('Plan Manager', 'Admin'),
            description: T._('Create a Custom Plan and extend a free trial on Shopify.', 'Admin')
        }
    },
    {
        url: '/shopify-charge',
        component: ShopifyCharge,
        header: {
            title: T._('Shopify Charge', 'Admin'),
            description: T._('Create a Shopify charge for a seller.', 'Admin')
        }
    },
    {
        url: '/world-map',
        component: WorldMap,
        header: {
            title: T._('World Map', 'Admin')
        }
    },
    {
        url: '/marketplace-themes',
        component: MarketplaceThemes,
        header: {
            title: T._('Marketplace Themes', 'Admin'),
            description: T._('Create, edit, publish, and archive marketplace themes.', 'Admin')
        }
    }
];

export default administratorRoutes;
